import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

const Account = () => {
  const { user } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 6) {
      toast.error("Fjalëkalimi i ri duhet të ketë të paktën 6 karaktere");
      return;
    }
    if (next !== confirm) {
      toast.error("Fjalëkalimet nuk përputhen");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/api/auth/change-password", { current_password: current, new_password: next });
      toast.success("Fjalëkalimi u ndryshua");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Ndryshimi dështoi");
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls = "mt-1 w-full px-3 py-2.5 border border-zinc-300 rounded-md focus:outline-none focus:border-zinc-900 text-sm";

  return (
    <div data-testid="account-page" className="max-w-md">
      <h1 className="text-2xl font-medium text-zinc-900">Account</h1>
      <p className="text-sm text-zinc-500 mt-1">I kyçur si <span className="text-zinc-900 font-medium">{user?.username}</span></p>

      <form onSubmit={onSubmit} className="mt-8 bg-white border border-zinc-200 rounded-lg p-6 space-y-4">
        <div className="flex items-center gap-2 text-sm font-medium text-zinc-900">
          <KeyRound size={16} /> Ndrysho fjalëkalimin
        </div>
        <div>
          <label className="text-xs text-zinc-600">Fjalëkalimi aktual</label>
          <input data-testid="account-current-password" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} required />
        </div>
        <div>
          <label className="text-xs text-zinc-600">Fjalëkalimi i ri</label>
          <input data-testid="account-new-password" type="password" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} required />
        </div>
        <div>
          <label className="text-xs text-zinc-600">Konfirmo fjalëkalimin e ri</label>
          <input data-testid="account-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} required />
        </div>
        <button data-testid="account-submit-btn" type="submit" disabled={submitting} className="w-full bg-zinc-900 text-white text-sm tracking-wide py-2.5 rounded-md hover:bg-zinc-800 transition disabled:opacity-60 flex items-center justify-center gap-2">
          {submitting && <Loader2 size={14} className="animate-spin" />} Ruaj fjalëkalimin e ri
        </button>
      </form>
    </div>
  );
};

export default Account;
